export default "__VITE_ASSET__CCbjwlAQ__"